/**
 * Exposing the __CONFIG__ object declared in webpack.DefinePlugin to
 * our typescript context so it looks like a module, not a global variable
 */

declare let __CONFIG__: any;

export interface IConfig {
  marketingSiteUrl: string;
  siteRootUrl: string;
  profileApiUrl: string;
  profileApiRoot: string;
  umbracoApiUrl: string;
  monickerApiUrl: string;
  liteAgentApiUrl: string;
  userAccountApiUrl: string;
  webMediaApiUrl: string;
  webMediaImageUrl: string;
  locationsApiUrl: string;
  billingApiUrl: string;
  gtm: {
    gtmId: string;
  };
  braze: {
    baseUrl: string;
    apiKey: string;
  };
  isDev?: boolean;
}

export const config: IConfig = {
  ...__CONFIG__,
};

export interface ICompileTimeError {
  cause?:
    | {
        errors: {
          [key: string]: string[];
        }[];
        status: number;
        title: string;
        traceId: string;
        type: string;
        message?: string;
        code?: number;
      }
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    | any;
  message?: string;
}

export interface RecurlyError {
  RecurlyError: {
    params: { param: string }[];
  };
}

export const JOINING_APP_ROUTES = {
  ROOT: "/",
  LEGACY_JOIN: "/join",
  BASE: "/joining",
  RESUME: "/resume",
  PERFORMER: {
    ROOT_WELCOME: "/performer",
    MAIN: "/performer/join",
    COMPLETE: "/performer/complete",
    PREVIOUSLY_COMPLETE: "/performer/previously-complete",
  },
  YOUNG_PERFORMER: {
    ROOT_WELCOME: "/young-performer",
    MAIN: "/young-performer/join",
    COMPLETE: "/young-performer/complete",
  },
  CASTING_DIRECTOR: {
    ROOT_WELCOME: "/casting",
    MAIN: "/casting/join",
    COMPLETE: "/casting/complete",
    MEMBER_COMPLETE: "/casting/member-complete",
    RESUME: "/casting/resume",
  },
  GRADUATE: {
    START_APP: "/graduate",
    CONTINUE_APP: "/graduate/continue",
    ABOUT_YOU: "/graduate/about-you",
    DETAILS: "/graduate/details",
    REVIEW: "/graduate/review",
    TRANSFER_PROFILE: "/graduate/transfer",
    SUBSCRIPTION: "/graduate/subscription",
    CHECKOUT_JOINING: "/graduate/checkout-joining",
    CHECKOUT: "/graduate/checkout",
    COMPLETE: "/graduate/complete",
  },
  AGENT: {
    ROOT_WELCOME: "/agent",
    MAIN: "/agent/join",
    COMPLETE: "/agent/complete",
  },
  NOT_FOUND: "/404",
};
